@if (message()) {
  <div class="global-loading">
    <div class="message">
      <src-loading [progress]="progress() ?? null" />
      {{ message() || '' }}
    </div>
  </div>
}
